<template>
  <organism-site-create-edit />
</template>

<script>
import OrganismSiteCreateEdit from "@/components/organisms/globalSetting/dataManagement/site/OrganismSiteCreateEdit.vue"

export default {
  components: { OrganismSiteCreateEdit },
}
</script>

<style></style>
